<template>
    <div>
        <div class="header">
            <van-icon name="arrow-left" class="back_icon" @click="back"/>
            <span class="lh_title" v-if="$route.meta.title">
            {{ $route.meta.title }}</span>
        </div>
        <div class="user_logff" :class="{'lf_step2': step == 2 || step == 3}" v-loading="ld">
            <div v-if="step&&!ld">
            <div class="step0" v-if="step == -1">
                <div class="box">
                    <div class="tit">提示</div>
                    <p>账号当前无法申请注销，建议您先 尝试以下方式：</p>
                    <p>1.余额过多，请先提现 </p>
                    <p>2.商品出售中，请先下架 </p>
                    <p>3.提现未到账，请等候1-2个工作日</p>
                </div>
                <van-button round class="confirm" @click="$router.push({name: 'user.center'})">知道了</van-button>
            </div>
            <!-- 发送验证码 -->
            <div class="step1" v-if="step == 1">
                <el-form :model="actionData" ref="form" :show-message="true" @submit.native.prevent>
                    <el-form-item>
                        <div class="ipt phone">
                            <span>+86</span>
                            <el-input readonly :value="userData.username"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="code" :rules="rules.code">
                        <div class="ipt code">
                            <el-input 
                                v-model="actionData.code" 
                                type="number"
                                oninput="if(value.length > 6) value=value.slice(0, 6)" 
                                placeholder="输入验证码"
                                ref="code"
                            >
                            </el-input>
                            <el-button :disabled="disabled" :class="['btn_primary',{'btn_disabled': disabled}]"
                                @click="sendCode">
                                {{ buttonName }}
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="tips">短信将发送至您的绑定手机</div>
                <el-button class="next_btn" @click="next1" :disabled="actionData.code.length < 6" :loading="loading1">
                    下一步</el-button>
            </div>
            <!-- 重要提示 -->
            <div class="step2" v-else-if="step == 2">
                <div class="txt_box">
                    <van-image class="warn" :src="require('../../../assets/bx/logoff/warning.png')"></van-image>
                    <div class="tit1">重要提示</div>
                    <div class="tit2">注销前请认真阅读一下重要提醒。<br /> 账号注销后，您将无法再使用该账号，包括不限于:</div>
                    <p>1.无法登录、使用交易平台账号，并移除该账号下所 有登录方式。</p>
                    <p>2.账号头像重置为默认头像、昵称重置为"用户已注销。 </p>
                    <p>3.移除该账号下的实名认证信息。 </p>
                    <p>4.该账号下的个人资料和历史信息都将无法找回。 </p>
                    <p>5.账号中所有的余额、资产及权益将被清除，且无法 找回。 </p>
                    <p>6.无法继续在进行交易、售后等流程。 </p>
                    <p>7.账号注销审核通过后，账号将进入30天的冻结期该 手机号将无法进行注册、登陆等行为，请谨慎操作。</p>
                </div>
                <div class="check">
                    <el-checkbox v-model="agree">
                        我已知晓并同意<span @click.stop="step = 3">《交易平台账号注销须知》</span>
                    </el-checkbox>
                </div>
                <el-button :disabled="!agree" class="sqzx_btn" @click="step = 4">申请注销</el-button>
            </div>
            <!-- 交易平台账号注销须知 -->
            <div class="step3" v-else-if="step == 3">
                <div class="txt_box">
                    <div class="tit">《交易平台账号注销须知》</div>
                    <p class="indent">在您申请注销账号前，请您仔细阅读、充分理解《交易平台账号注销须知》(以下简称为“注销须知")的所有内容。当您按照注销提示填写并提交注销申请时，即表示您已充分阅读、理解本注销须知的全部内容。如您不同意注销须知的相关条款和约定，请您及时停止注销程序。</p>
                    <p class="indent">交易平台官方在此善意的提醒您，如交易平台账号下的信息对您来说十分重要，您应在点击申请注销之前将所有数据和信息(包括但不限于个人资料、交易记录)自行备份。注销成功后，我们将删除您的个人信息，使其保持不可被搜索、访问的状态，或将其进行匿名化处理。您知晓并理解，根据法律法规的要求，G买卖交易行官方将对您在本站内的交易记录保存三年。</p>
                    <p class="indent">一、账号注销后，您将无法再使用该账号。您确认注销的行为即代表您接受所有注销后果，包括但不限于：</p>
                    <p>1、无法登录、使用交易平台账号，并移除该账号所有登录方式，该账号注销后三十天内不能重新注册</p>
                    <p>2、账号头像重置为默认头像、昵称重置为"用户已注销"</p>
                    <p>3、移除该账号下的实名认证信息</p>
                    <p>4、该账号下的个人资料和历史信息都将无法找回</p>
                    <p>5.账号中所有的余额、资产及权益将被清除，且无法找回</p>
                    <p>6、无法继续在商城进行交易、售后等流程</p>
                    <p>7、账号注销审核通过后，账号将进入30天的冻结期该手机号将无法进行注册、登陆等行为，请谨慎操作</p>
                    <p class="indent">二、在您的交易平台账号注销期间，如果您的账号涉及争议纠纷，包括但不限于举报、投诉、仲裁、诉讼、涉嫌违法违规行为、相关国家机关调查等，或账户存在被盗号风险的，G买卖交易行官方有权限暂停您的账号注销程序或限制相同信息在注销后再次注册。</p>
                    <p class="indent">三、账号一旦注销，您与交易平台曾签署过的相关协议、其他权利义务性文件等相应终止(但已约定继续生效或法律另有规走的除外)。但您注销交易平台账号并不代表该账号注销前的帐号行为和相关责任得到减轻或豁免。</p>
                </div>
                <van-button round class="confirm" @click="step = 2;agree = true">我已阅读</van-button>
            </div>
            <!-- 原因 -->
            <div class="step4" v-else-if="step == 4">
                <div class="tit"><span style="color: red;">*</span>请选择注销原因&nbsp;&nbsp;(必填)</div>
                <div class="reason" @click="reason = 0">
                    <div class="word">手机号不再使用</div>
                    <div class="radio" :class="{'check': reason == 0}"></div>
                </div>
                <div class="reason" @click="reason = 1">
                    <div class="word">不想用G买卖交易行了</div>
                    <div class="radio" :class="{'check': reason == 1}"></div>
                </div>
                <div class="other" @click="chooseOther">
                    <div class="reason">
                        <div class="word">其他原因</div>
                        <div class="radio" :class="{'check': reason == 2}"></div>
                    </div>
                    <van-field 
                        v-model="other_reason"
                        type="textarea" 
                        placeholder="请填写具体原因，最多100个字" maxlength="100" 
                        show-word-limit 
                        :readonly="reason != 2" 
                        ref="other"
                    />
                </div>
                <div class="tit">添加图片说明&nbsp;&nbsp;(可选填,最多上传3张)</div>
                <div class="upload_area">
                    <van-uploader 
                        v-model="list" 
                        multiple 
                        :max-count="3" 
                        :accept="'image/*'"
                        :after-read="afterRead"
                        upload-icon="plus"
                        @delete="deleteUpload"
                    />
                </div>
                <el-button :disabled="!(reason == 0 || reason == 1 || (reason == 2 && other_reason != ''))" :loading="apply_loading" class="sqzx_btn" @click="apply">申请注销</el-button>
            </div>
            <!-- 注销状态 申请审核中-->
            <div class="step5" v-else-if="step == 5">
                <div class="box">
                    <van-icon name="passed" class="icon"/>
                    <div class="tit">账号注销申请提交成功</div>
                    <p>您的账号注销申请正在审核，预计1-2个工作日<br/>
                    期间您可在账号注销界面进行取消注销操作</p>
                </div>
                <van-button round class="cancel" @click="$router.push({name: 'user.center'})">确认返回我的</van-button>
                <van-button round class="confirm" @click="cancel">取消账号注销</van-button>
            </div>
            <!-- 注销状态 注销拒绝-->
            <div class="step6" v-else-if="step == 6">
                <div class="box">
                    <van-icon name="close" class="icon"/>
                    <div class="tit">账号注销申请已被拒绝</div>
                    <p>您的账号注销申请由于以下原因未通过：</p>
                    <i>{{ reason_fail }}</i>
                </div>
                <van-button round class="confirm" @click="kefu">联系客服</van-button>
                <van-button round class="confirm" @click="reLogoff">重新提交注销申请</van-button>
            </div>
            <!-- 注销状态 注销确认-->
            <div class="step7" v-else-if="step == 7">
                <div class="box">
                    <van-icon name="underway-o" class="icon"/>
                    <div class="tit">账号注销确认</div>
                    <p>您的账号注销申请已通过，账号剩余注销时间</p>
                    <i>
                        <van-count-down :time="count_time" format="DD 天 HH 时 mm 分 ss 秒" @finish="finish"/>
                    </i>
                </div>
                <van-button round class="confirm" @click="cancel">取消账号注销</van-button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {httpRequest} from '@/ajax'
    export default {
        data() {
            return {
                ld:true,
                step: null,
                actionData: {
                    code: ''
                },
                disabled: false,
                buttonName: '获取验证码',
                time: 59,
                loading1: false,

                agree: false,

                reason: -1,
                other_reason: '',
                list: [],
                uploadimgs: [],
                apply_loading: false,

                currentServeTime: '',
                count_time: 0,

                reason_fail: '',

                id: null,//注销失败的id
            }
        },
        computed: {
            userData() {
                return this.$store.getters.state.userData || {};
            },
            rules() {
                const {
                    captcha
                } = this.$store.getters.rules;
                return {
                    code: captcha,
                };
            },
            differTime() {
                return this.$store.state.differTime;
            },
        },
        created() {
            this.getTime()
            this.getStatus()
        },
        methods: {
            getTime() {
                var now = new Date();
                this.currentServeTime = new Date(now.valueOf() - this.differTime);
            },
            async getStatus() {
                // this.step = 4
                // setTimeout(() => {
                //     this.ld = false
                // },1000)
                await this.$Ajax('login-out/check-login-out',{},'get').then(rs => {
                    if(rs.code == 407) {
                        this.step = -1
                        this.$Message.error(rs.msg)
                    }else if(rs.code == 200) {
                        if(rs.data.status == 999) {
                            this.step = 1
                        }else if(rs.data.status == 0) {
                            this.step = 5
                        }else if(rs.data.status == 1) {
                            this.step = 7
                            this.count_time = new Date(rs.data.loginOut.verify_time.replace(/-/g, '/')).getTime() + 604800000 - this.currentServeTime.getTime()
                        }else if(rs.data.status == 2) {
                            this.id = rs.data.loginOut.id
                            this.reason_fail = rs.data.loginOut.reason_fail
                            this.step = 6
                        }else if(rs.data.status == 3) {
                            this.step = 1
                        }
                    }else {
                        this.$Message.error(rs.msg)
                    }
                }).finally(() => {
                    this.$forceUpdate()
                    setTimeout(() => {
                        this.ld = false
                    },500)
                })
            },
            back() {
                if(this.step == 1 || this.step == 5 || this.step == 6 || this.step == 7 || this.step == -1) {
                    this.$router.push({name: 'user.center'})
                }else if(this.step == 2) {
                    this.step = 1
                }else if(this.step == 3) {
                    this.step = 2
                }else if(this.step == 4) {
                    this.step = 2
                }
            },
            sendCode() {
                var that = this
                that.disabled = true;
                that.$Ajax('login-out/send-msg',{},'get').then(rs => {
                    if(rs.code == 200) {
                        that.buttonName = "已发送(60s)"
                        let interval = window.setInterval(function () {
                            that.buttonName = "已发送(" + that.time + "s)";
                            that.time--;
                            if (that.time < 0) {
                                that.buttonName = "重新发送";
                                that.time = 59;
                                that.disabled = false;
                                window.clearInterval(interval);
                            }
                        }, 1000);
                        setTimeout(() => {
                            that.$refs.code.focus()
                        }, 50);      
                    }else {
                        that.buttonName = "重新发送";
                        that.time = 59;
                        that.disabled = false;
                    }
                })
            },
            next1() {
                this.loading1 = true
                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.$Ajax('login-out/send-msg',{
                            code: this.actionData.code
                        },'get').then(rs => {
                            if(rs.code == 200) {
                                this.step = 2
                                setTimeout(() => {
                                    this.loading1 = false
                                }, 2000)
                            }else {
                                setTimeout(() => {
                                    this.loading1 = false
                                }, 2000)
                            }
                        })
                        
                    }
                })
            },
            chooseOther() {
                this.reason = 2
                setTimeout(() => {
                    this.$refs.other.focus()
                },50)
            },
            afterRead(file) {
                file.status = 'uploading';
                file.message = '上传中...';
                if(file.length) {
                    for(var i = 0; i < file.length; i++) {
                        httpRequest('wallet/upload-img',file[i].file).then(rs => {
                            if(rs.data.code == 200) {
                                this.uploadimgs.push({url: rs.data.data.path})
                                this.list = this.uploadimgs
                                file.status = 'done'
                            }else {
                                file.status = 'failed'
                            }
                        })
                    }
                }else {
                    httpRequest('wallet/upload-img',file.file).then(rs => {
                        if(rs.data.code == 200) {
                            this.uploadimgs.push({url: rs.data.data.path})
                            this.list = this.uploadimgs
                            file.status = 'done'
                        }else {
                            file.status = 'failed'
                        }
                    })
                }
            },
            deleteUpload(file,detail) {
                this.uploadimgs.splice(detail.index,1)
            },
            apply() {
                this.apply_loading = true
                var reason = ''
                if(this.reason == 0) {
                    reason = '手机号不再使用'
                }else if(this.reason == 1) {
                    reason = '不想用G买卖交易行了'
                }else if(this.reason == 2) {
                    reason = this.other_reason
                }
                var obj = {
                    reason
                }
                if(this.id) {
                    obj.id = this.id
                }
                if(this.uploadimgs.length != 0) {
                    obj.imgs = this.uploadimgs.map(item => item.url)
                }
                this.$Ajax('login-out/submit',obj).then(rs => {
                    if(rs.code == 200) {
                        setTimeout(() => {
                            this.apply_loading = false
                            this.step = 5
                        },2000)
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.apply_loading = false
                    },2000)
                })
            },
            //取消注销
            cancel() {
                this.$Ajax('login-out/cancel',{},'get').then(rs=> {
                    if(rs.code == 200) {
                        this.$toast.success({
                            message: '取消账号注销成功',
                            duration: 1500,
                            onClose: () => {
                                this.$router.push({ name: 'user.center' })
                            }
                        })
                    }
                })
            },
            kefu() {
                window.location.href = 'https://livechathuyu.gmmsj.com/index/index/kefu?u=6265f471b483e&platform=8&game_id=8889&game_name=G买卖&uid=8_'+ this.userData.user_id +'&phone=' + this.userData.username
            },
            finish() {
                this.$toast({
                    message: '注销成功',
                    duration: '2000',
                    onClose: () => {
                        this.$store.dispatch('logout')
                    }
                })
            },
            reLogoff() {
                this.$store.dispatch("getUserData",true)
                this.step = 1;
            }
        },
        watch: {
            $route: {
                immediate:true,
                handler(e) {

                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .header {
        position: fixed;
        top: 0;
        left: 50%;
        width: 100%;
        max-width: 525px;
        transform: translateX(-50%);
        z-index: 100;
        height: 5rem;
        line-height: 5rem;
        text-align: center;
        background: url(../../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
        background-color: #fff;
        .back_icon,
        .lh_title {
          color: #fff;
          font-size: 1.6rem;
        }
        .back_icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          font-size: 2rem;
          cursor: pointer;
        }
    }
    .user_logff {
        padding: 2rem;
        min-height: calc(var(--vh, 1vh) * 100 - 5rem);
        &.lf_step2 {
            padding: 2rem 1rem;
        }
    }
    .step1 {
        .el-form-item {
            margin-bottom: 2rem;

            &:nth-last-of-type(1) {
                margin-bottom: 1.6rem;
            }
        }

        /deep/.el-form-item__error {
            left: 2rem;
        }

        .ipt {
            width: 33.5rem;
            height: 5rem;
            background-color: #fff;
            border-radius: 10rem;
            display: flex;
            align-items: center;
            font-size: 1.6rem;
            padding: 0 1.5rem 0 1.9rem;

            /deep/.el-input {
                .el-input__inner {
                    border: none;
                    font-size: 1.6rem;
                    color: #000;
                    height: 5rem;
                    line-height: 5rem;
                    padding: 0;
                }
            }
        }

        .phone {
            span {
                color: #fe6455;
                margin-top: 0.1rem;
                padding-right: 1rem;
                position: relative;

                &::after {
                    content: '';
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: .1rem;
                    height: 1.2rem;
                    background-color: #8b8b8b;
                }
            }

            /deep/.el-input__inner {
                padding-left: 1rem !important;
            }
        }

        .code {
            .btn_primary {
                padding: 0;
                padding-left: 1.5rem;
                width: 9.5rem;
                border: none;
                font-size: 1.6rem;
                color: var(--theme);
                background-color: transparent;
                position: relative;

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: .1rem;
                    height: 1.2rem;
                    background-color: #8b8b8b;
                }

                &.btn_disabled {
                    color: #999;
                }
            }
        }

        .tips {
            text-align: center;
            font-size: 1.2rem;
            color: #999;
            margin-bottom: 3.3rem;
        }

        .next_btn {
            width: 100%;
            height: 5rem;
            background-color: var(--theme);
            color: #fff;
            font-size: 1.6rem;
            border-radius: 10rem;
            outline: none;
            border: none;

            &:active {
                opacity: 0.9;
            }

            &:disabled {
                background-color: #999;

                &:active {
                    opacity: 1;
                }
            }
        }
    }
    .txt_box {
        padding: 1rem 1rem 2rem;
        background-color: #fff;
        border-radius: 1rem;
        margin-bottom: 2rem;
    }
    .step2 {
        .warn {
            width: 8rem;
            height: 6.8rem;
            display: block;
            margin: 0 auto 1rem;
        }
        .tit1 {
            font-size: 1.6rem;
            font-weight: 700;
            text-align: center;
            color: #555;
            margin-bottom: 2rem;
        }
        .tit2 {
            font-size: 1.4rem;
            color: #555;
            text-align: center;
            margin-bottom: 2rem;
            line-height: 1.5;
        }
        p {
            font-size: 1.4rem;
            color: #555;
            line-height: 1.5;
        }
        .check {
            height: 2rem;
            width: 28rem;
            overflow: visible;
            position: relative;
            /deep/.el-checkbox__inner {
                width: 1.8rem;
                height: 1.8rem;
                &::after {
                    height: 1rem;
                    left: 0.5rem;
                }
            }
            /deep/.el-checkbox {
              align-items: flex-start;
              padding-left: 0.8rem;
              .el-checkbox__label {
                margin-top: 0.1rem;
                font-size: 1.3rem;
                line-height: 1.8rem;
                    span {
                        color: var(--theme);
                    }
                }
            }
        }
    }
    .sqzx_btn {
        display: block;
        margin: 3rem auto 0;
        width: 33.5rem;
        height: 5rem;
        border-radius: 10rem;
        color: #fff;
        background-color: var(--theme);
        border: none;
        font-size: 1.6rem;
        &:active {
            opacity: 0.9;
        }
        &:disabled {
            background-color: #999;
            &:active {
                opacity: 1;
            }
        }
    }
    .step3 {
        .txt_box {
            padding-top: 2rem;
        }
        .tit {
            font-size: 1.6rem;
            color: #000;
            text-align: center;
            margin-bottom: 2rem;
        }
        p {
            font-size: 1.4rem;
            color: #555;
            line-height: 1.8;   
            word-break: break-all; 
        }
        .indent {
            text-indent: 2.8rem;
        }
        .confirm {
            width: 100%;
            height: 5rem;
            color: #fff;
            font-size: 1.6rem;
            background-color: var(--theme);
        }
    }
    .step4 {
        .tit {
            font-size: 1.6rem;
            margin-bottom: 2rem;
            color: #000;
        }
        .reason {
            height: 5rem;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 1.5rem;
            border-radius: .6rem;
            margin-bottom: 1.5rem;
            cursor: pointer;
            .word {
                font-size: 1.6rem;
                color: #555;
            }
            .radio {
                width: 1.4rem;
                height: 1.4rem;
                border-radius: 50%;
                border: .1rem solid #555;
                transition: all ease .3s;
                -webkit-transition: all ease .3s;
                -o-transition: all ease .3s;
                -moz-transition: all ease .3s;
                &.check {
                    background-color: var(--theme);
                    border-color: var(--theme);
                    position: relative;
                    &::after {
                        content: "";
                        width: 0.3rem;
                        height: 0.6rem;
                        border: .2rem solid #fff;
                        border-top: none;
                        border-left: none;
                        position: absolute;
                        left: 50%;
                        top: 45%;
                        transform: translate(-50%,-50%) rotate(40deg);
                    }
                }
            }
        }
        .other {
            border-radius: .6rem;
            background-color: #fff;
            margin-bottom: 2rem;
            .reason {
                margin-bottom: 0;
            }
        }
        .van-field {
            padding: 0 1.5rem 1.5rem;
            font-size: 1.4rem;
        }
        .upload_area {
            /deep/.van-uploader {
                .van-uploader__preview {
                    margin: 0 1.3rem 0 0;
                    &:nth-last-of-type(1) {
                        margin-right: 0;
                    }
                    .van-uploader__preview-delete {
                        width: 1.4rem;
                        height: 1.4rem;
                        background-color: var(--theme);
                        color: #fff;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        left: unset;
                        top: unset;
                        bottom: .5rem;
                        right: .5rem;
                        padding: 0;
                        .van-icon-cross {
                            position: unset;
                            transform: scale(0.8);
                            font-size: 1.2rem;
                        }
                    }
                }
                .van-uploader__upload,
                .van-uploader__preview-image {
                    width: 10.2rem;
                    height: 10.2rem;
                    background-color: #fff;
                    border-radius: .6rem;
                    overflow: hidden;
                    margin: 0;
                }
                .van-icon-plus {
                    font-size: 2.5rem;
                    color: #BFBFBF;
                    font-weight: 700;
                }
            }
        }
    }
    .step0,
    .step5,
    .step6,
    .step7 {
        .box {
            padding: 2rem 0;
            background-color: #fff;
            border-radius: 1rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            .icon {
                color: var(--theme);
                font-size: 5rem;
                margin-bottom: 1.5rem;
            }
            .tit {
                font-size: 1.6rem;
                color: #555;
                margin-bottom: 1.5rem;
            }
            p {
                color: #999;
                font-size: 1.2rem;
                text-align: center;
                word-break: break-all;
            }
            i {
                font-size: 1.2rem;
                font-style: normal;
                margin-top: .8rem;
                color: var(--theme);
                word-break: break-all;
                /deep/.van-count-down {
                    color: var(--theme);
                    font-size: 1.2rem;
                }
            }
        }
        .cancel,
        .confirm {
            width: 100%;
            height: 5rem;
            color: #fff;
            margin-top: 2rem;
            font-size: 1.6rem;
        }
        .cancel {
            background-color: #999;
        }
        .confirm {
            background-color: var(--theme);
        }
    }

    .step0 {
        .box {
            display: block !important;
            padding: 2rem;
            .tit {
                text-align: center;
            }
            p {
                text-align: start !important;
                line-height: 1.8;
            }
        }
    }
</style>